/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Permission_TextInputs */

const en_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact your system administrator for help.`)
};

const fr_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez contacter votre administrateur système pour obtenir de l’aide.`)
};

const de_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wenden Sie sich an Ihren Systemadministrator, um Hilfe zu erhalten.`)
};

const it_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per assistenza, contattare l'amministratore di sistema.`)
};

const ru_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, обратитесь за помощью к системному администратору.`)
};

const es_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comuníquese con el administrador del sistema para obtener ayuda.`)
};

const zh_cn2_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请联系您的系统管理员寻求帮助。`)
};

const ja_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートが必要な場合は、システム管理者にお問い合わせください。`)
};

const hi_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया सहायता के लिए अपने सिस्टम एडमिनिस्ट्रेटर से संपर्क करें।`)
};

const pt_pt2_team_manager_no_permission_text = /** @type {(inputs: Team_Manager_No_Permission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, entre em contato com o administrador do sistema para obter ajuda.`)
};

/**
* | output |
* | --- |
* | "Please contact your system administrator for help." |
*
* @param {Team_Manager_No_Permission_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_permission_text = /** @type {((inputs?: Team_Manager_No_Permission_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Permission_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_no_permission_text(inputs)
	if (locale === "de") return de_team_manager_no_permission_text(inputs)
	if (locale === "it") return it_team_manager_no_permission_text(inputs)
	if (locale === "ru") return ru_team_manager_no_permission_text(inputs)
	if (locale === "es") return es_team_manager_no_permission_text(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_no_permission_text(inputs)
	if (locale === "ja") return ja_team_manager_no_permission_text(inputs)
	if (locale === "hi") return hi_team_manager_no_permission_text(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_no_permission_text(inputs)
	return en_team_manager_no_permission_text(inputs)
});